import { data } from 'autoprefixer';
import { DemoViewerApiService } from './demo-viewer-api.service';
import { Injectable } from '@angular/core';
import { PointMatch } from './models/matching-points';

@Injectable({
  providedIn: 'root',
})
export class PointMatchService {
  constructor(private apiService: DemoViewerApiService) {}
  private pointMatches: PointMatch[] = [];

  // Map for quick lookup by current_point_uuid and match_report_id
  private matchLookup: Map<string, Map<string, PointMatch>> = new Map();

  public updatePointMatches(reportId: string, floorId: string): void {
    this.apiService.getMatchingPoints(reportId, floorId).subscribe((matches) => {
      this.pointMatches = matches.data;
      if (this.pointMatches.length > 0) this.buildLookupMaps();
    });
  }

  /**
   * Build lookup maps for efficient querying
   */
  private buildLookupMaps(): void {
    this.matchLookup.clear();

    this.pointMatches.forEach((match) => {
      if (!this.matchLookup.has(match.current_point_uuid)) {
        this.matchLookup.set(match.current_point_uuid, new Map());
      }
      this.matchLookup.get(match.current_point_uuid)?.set(match.match_report_id, match);
    });
  }

  /**
   * Get match information by current point UUID and match report ID
   * @param currentPointUuid The UUID of the current point
   * @param matchReportId The ID of the report to match against
   * @returns Object containing angle_offset and match_point_uuid, or null if no match found
   */
  getMatchInfo(
    currentPointUuid: string,
    matchReportId: string,
  ): { angle_offset: number; match_point_uuid: string } | null {
    const match = this.matchLookup.get(currentPointUuid)?.get(matchReportId);

    if (!match) {
      return null;
    }

    return {
      angle_offset: match.angle_offset,
      match_point_uuid: match.match_point_uuid,
    };
  }

  clear(): void {
    this.pointMatches = [];
    this.matchLookup.clear();
  }
}
